<template>
  <rbv-dropdown
    :is-open="isOpen"
    :backdrop-style="'transparent'"
    align="right"
    :class="$style.sorter"
    @close="toggle"
  >
    <div slot="toggler" :class="$style.togglerContainer">
      <button class="rbButton" :class="styleSize.toggler" @click="toggle">
        <span :class="$style.togglerText">{{ toggleText }}</span>
        <i class="material-icons" :class="sorter.order !== 'desc' && styleSize.sortAsc" @click.stop="invertSort">sort</i>
      </button>
    </div>
    <div slot="dropdown" :class="$style.dropdownContainer" @click="toggle">
      <button
        v-for="field in sorts"
        :key="field.id"
        class="rbButtonMenuItem"
        @click="onDestinationSortChanged(field.id)"
      >
        {{ field.text }}
      </button>
    </div>
  </rbv-dropdown>
</template>

<script>
  import rbEventsMixin from 'vRoot/_mixins/RbEventsMixin.vue'
  import RbvDropdown from 'vRoot/_core/RbDropdown.vue';
  import sortService from 'root/v-components/travel-destinations-map/travel-destinations-map-table/suppliers-sort-service';

  export default {
    name: 'RbvTravelDestinationsMapSuppliersTableShrinkedSorter',
    components: { RbvDropdown },
    mixins: [rbEventsMixin],
    props: {
      size: {
        type: String, // 'small' or 'large'
        required: true
      },
      sorter: {
        type: Object,
        required: false,
        default: () => {}
      }
    },
    data(){
      return {
        isOpen: false,
        sorts: sortService.listSorts()
      }
    },
    computed: {
      styleSize () {
        switch (this.size){
          case 'small':
            return {
              toggler: this.$style.toggler,
              sortAsc: this.$style.sortAsc
            }
          case 'large':
            return {
              toggler: this.$style.toggler,
              sortAsc: this.$style.sortAsc
            }
          default:
            return {}
        }
      },
      toggleText(){
        const sort = sortService.findById(this.sorter.id)
        return sort ? `${sort.text}` : 'Not Sorted'
      }
    },
    methods: {
      toggle() { this.isOpen = !this.isOpen },
      onDestinationSortChanged(id){ this.$rbEmit(sortService.createSortEvent(id)) },
      invertSort() { this.onDestinationSortChanged(this.sorter.id) }
    }
  }
</script>

<style lang="stylus" module>

  .togglerContainer {
    display flex
  }

  .toggler {
    white-space: nowrap;
    padding: 0 3px 0 16px
    text-align: left;
    line-height 2.5 !important
    border-radius 20px
    display flex
    align-items center
    width fit-content
    max-width 200px

    &:hover {
      position relative
      z-index 1
      border-color: #00b8ab
    }

    &:focus{
      border-color: #00b8ab
    }
  }

  .sorter{
    padding 0 5px
  }

  .sorter :global(.rbvDropDown) {
    right: 0 !important;
    top 100% !important
  }

  .toggler i{
    line-height 1.7 !important
  }

  .togglerText {
    width: calc(100% - 15px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space nowrap
  }

  .dropdownArrow {
    color #78909C
  }

  .dropdownOpenArrow {
    composes dropdownArrow
    transform rotateX(180deg)
  }

  .sortAsc {
    transform: rotateX(180deg);
    color #00b8ab !important;
  }

  .dropdownContainer {
    background: #FFFFFF;
    border: 1px solid #CFD8DC;
    margin-top: 4px;
    border-radius: 3px;
    overflow: hidden;
    box-shadow : 0 0 5px 1px rgba(0, 0, 0, 0.18);
  }

</style>
